module.exports = __webpack_public_path__ + "img/21.4fab8813.png";